import React from 'react';
import { IIconProps } from './utils';

export const ShareLink = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M19 7C19 5.34315 20.3431 4 22 4C23.6569 4 25 5.34315 25 7C25 8.65685 23.6569 10 22 10C20.3431 10 19 8.65685 19 7Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      d="M19 23C19 21.3431 20.3431 20 22 20C23.6569 20 25 21.3431 25 23C25 24.6569 23.6569 26 22 26C20.3431 26 19 24.6569 19 23Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      d="M4 15C4 13.3431 5.34315 12 7 12C8.65685 12 10 13.3431 10 15C10 16.6569 8.65685 18 7 18C5.34315 18 4 16.6569 4 15Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path d="M19 22L10 17" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" />
    <path d="M19 9L10 14" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" />
  </svg>
);
